import type { ModalOptions, ModalResult } from '@/types/stores/modalStore.type';
import { useModalStore } from '@/stores/modalStore';

export async function displayModal(options: ModalOptions): Promise<ModalResult> {
  const modal = useModalStore();
  return await modal.openModal(options);
}
